import { useMemo } from "react";
import { OpportunityTypeFilter } from "../../../../../legacy/types/companyFilter";
import { capitalize } from "@mui/material";

export const useOpportunityTypeLabel = (
  opportunityType: OpportunityTypeFilter | undefined
): string => {
  return useMemo(() => {
    if (!opportunityType?.type) {
      return "All Companies";
    }

    return opportunityType.type
      .toLowerCase()
      .replace("_", " ")
      .split(" ")
      .map(capitalize)
      .join(" ");
  }, [opportunityType]);
};
